<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <TemplateDetail :form-data="data" slot-scope="{data}"></TemplateDetail>
  </l-cache>
</template>
<script>
import TemplateDetail from './templateDetail'
export default {
  name: 'templateDetailBox',
  components: {TemplateDetail},
  methods: {
    async getItem (key) {
      let pagination = {pages: 1, rowsPerPage: 10}
      let url = '/messageApi/admin/getMsgTmplt'
      let {items, amount} = await this.$store.dispatch('message/getList', {pagination,search: {key: 'id', value: this.$route.query.id}, url: url})
      if (items.length !== 0) {
        return items[0]
      }
      else {
        this.$L.alert('error', {message: '查询失败，未查到该消息模板'})
      }
    }
  }
}
</script>
